export default __webpack_public_path__ + "static/media/next-button-usage.66e41858.png";